export const OverlayFunctionTranslationEN = {};
